import theme from 'theme.json';

export const defaultArrowProps = {
  arrowColor: theme.extend.colors.tertiary[600],
  arrowSize: 5
};
